module.exports = __webpack_public_path__ + "dcf68fd8.svg";